"use strict";

exports.__esModule = true;
exports.ReportThumbnail = ReportThumbnail;
var _react = _interopRequireDefault(require("react"));
var _ConfigurableLayout = require("../../ConfigurableLayout");
var _Widgets = require("../../Widgets");
var _excluded = ["width", "height", "report"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
/**
 * Shows a thumbnail for a report.
 */
function ReportThumbnail(_ref) {
  var width = _ref.width,
    height = _ref.height,
    report = _ref.report,
    extra = _objectWithoutPropertiesLoose(_ref, _excluded);
  var widgets = _react["default"].useContext(_Widgets.WidgetsContext);
  return /*#__PURE__*/_react["default"].createElement(_ConfigurableLayout.LayoutThumbnail, _extends({
    widgets: widgets.reportWidgets,
    config: report,
    width: width,
    height: height
  }, extra));
}